import React, { useEffect, useState } from "react";
import { Theme, useTheme } from "@mui/material/styles";
import { Grid, Typography } from "@mui/material";
import { LocalPhone } from "@mui/icons-material";

interface ButtonInfoCalendlyProps {
  PageFaq?: boolean;
}

const ButtonInfoCalendly: React.FC<ButtonInfoCalendlyProps> = ({}) => {
  // Integrazione Calendly
  useEffect(() => {
    const link = document.createElement("link");
    link.href = "https://calendly.com/assets/external/widget.css";
    link.rel = "stylesheet";
    document.head.appendChild(link);

    const script = document.createElement("script");
    script.src = "https://calendly.com/assets/external/widget.js";
    script.type = "text/javascript";
    script.async = true;
    document.head.appendChild(script);

    const handleCalendlyEvent = (e: MessageEvent) => {
      // Gestione degli eventi di Calendly qui (se necessario)
    };

    script.onload = () => {
      setTimeout(() => {
        if (
          window.Calendly &&
          typeof window.Calendly.initInlineWidgets === "function"
        ) {
          window.Calendly.initInlineWidgets();
        }
      }, 1000);
      window.addEventListener("message", handleCalendlyEvent);
    };

    return () => {
      window.removeEventListener("message", handleCalendlyEvent);
    };
  }, []);

  const openCalendlyPopup = () => {
    if (window.Calendly) {
      window.Calendly.showPopupWidget(
        "https://calendly.com/legalfarm/telefonata-informativa"
      );
    }
  };

  return (
    <>
      <div className="container-button-richiedi-info">
        <a
          className="nav-link  button-cta-final"
          style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
          onClick={openCalendlyPopup}
        >
          <Grid item xs={3} style={{ marginLeft: "10px" }}>
            <LocalPhone
              style={{ fontSize: "28px" }}
              className="color-primary"
            />
          </Grid>
          <Grid item xs={9} style={{ textAlign: "start", marginLeft: "5px" }}>
            <Typography
              className="color-primary text-20"
              style={{ fontWeight: 600 }}
            >
              Richiedi info
            </Typography>
          </Grid>
        </a>
      </div>
    </>
  );
};

export default ButtonInfoCalendly;
